import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ClassicReenrollmentAnalysisReason = () => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeReason.description.CLASSIC_RE_ENROLL"
  });
};
export default ClassicReenrollmentAnalysisReason;